import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=16a8ee68&scoped=true&"
import script from "./resourceList.vue?vue&type=script&lang=js&"
export * from "./resourceList.vue?vue&type=script&lang=js&"
import style0 from "./resourceList.vue?vue&type=style&index=0&id=16a8ee68&scoped=true&lang=less&"
import style1 from "./resourceList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8ee68",
  null
  
)

export default component.exports